(() => {
  function initAnimations() {
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  }
  initAnimations();

  function lenisScroll() {
    const lenis = new Lenis({
      duration: 2, // Default duration for vertical scrolling
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'both',
      gestureDirection: 'both',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
  })

    let scrollDuration = 2;
    const horizontalScrollDuration = 0.8;

    lenis.on('scroll', ({direction}) => {
      if (direction === 'horizontal') {
        if (scrollDuration !== horizontalScrollDuration) {
          scrollDuration = horizontalScrollDuration;
          lenis.setOptions({ duration: scrollDuration });
        }
      } else if (direction === 'vertical') {
        if (scrollDuration !== 1.2) {
          scrollDuration = 1.2;
          lenis.setOptions({ duration: scrollDuration });
        }
      }
    });

    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  }
  lenisScroll();
})();
